var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('LoggerList',{attrs:{"logger_type":"rain","title":"Nedbør","icon_marker_letter":"R"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }